import { Button, ButtonProps, Stack, Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'

export const StatusChecksHeader: React.FC<{
  title: string
  description: string
  buttonText?: string
  buttonProps?: ButtonProps
}> = ({ title, description, buttonText, buttonProps }) => {
  return (
    <Stack
      direction="column"
      gap={5}
      justifyContent="space-between"
      sx={{
        marginBottom: 5
      }}
    >
      <Stack
        alignItems="center"
        direction="row"
        gap={5}
        justifyContent="space-between"
      >
        <Typography data-test-status-checks-header variant="h5">
          {title}
        </Typography>

        {buttonText && (
          <Button
            data-test-status-checks-header-button
            startIcon={<Icon icon="plus" />}
            variant="contained"
            {...buttonProps}
          >
            {buttonText}
          </Button>
        )}
      </Stack>

      <Stack>
        <Typography data-test-status-checks-header-text variant="body1">
          {description}
        </Typography>
      </Stack>
    </Stack>
  )
}
